import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";
import './About.css';

function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Kuku Namkeen | History</title>
                <link rel="canonical" href="https://kukunamkeen.com/about" />
            </Helmet>

            {/* Page Header Banner */}
            <section className="about-header-title">
                <div className="max-w-6xl mx-auto px-4">
                    <h1>KUKU'S HISTORY</h1>
                </div>
            </section>
            <img
                src="/Image/border-bottom-title.png"
                className="w-full header-title-image"
                alt=""
            />

            {/* History Content */}
            <section className="history-section">
                <div className="max-w-[1320px] mx-auto px-4 lg:px-8">

                    {/* About Our Brand */}
                    <div className="history-block">
                        <h3 className="heading-title mb-3">About us Brand</h3>
                        <p>
                            Jamnagar's Kachori is Famous Nationally &amp; Internationally Favourite namkeen for everyone.
                            KUKU Namkeen the name, the brand known for best namkeen (Specially Kachori's) in Jamnagar Since
                            1965.
                        </p>
                    </div>

                    {/* Founder Section */}
                    <div className="flex flex-col md:flex-row items-center gap-8 history-block">
                        <div className="w-full md:w-1/2">
                            <img
                                src="/Image/founders-photo.png"
                                className="w-full rounded-2xl"
                                alt="Founder Late Shree Pranlaal Sundarji Vasu"
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                        </div>
                        <div className="w-full md:w-1/2">
                            <h3 className="heading-title mb-3">The Originals Since 1965</h3>
                            <p>
                                <span className='text-black font-semibold'>Late Shree Pranlaal Sundarji</span> Vasu was Maker of KuKu Namkeen's Famous Signature Kachori
                                known as <span className='text-black font-semibold'>"Chapati Kachori".</span> He wented to sell this kachori out side of Factory &amp; Schools.
                            </p>
                            <p>
                                Jamnagar's Public Known him as <span className='text-black font-semibold'>"Ada Kachori Vala"</span> all like a lot this taste of kachori.
                            </p>
                        </div>
                    </div>

                    {/* Legacy Section */}
                    <div className="history-block text-center">
                        <h3 className="heading-title mb-3">The Making of a Legacy</h3>
                        <p>
                            <span className='text-black font-semibold'>Mr.Sandeep Kishorchandra Vasu</span> &amp; <span className='text-black font-semibold'>Mr.Bharat Kishorchandra Vasu</span> Grandson of Late Shree
                            Pranlaal Sundarji Vasu.both are young and pioneer for the making of namkeen's real taste.
                            they Start the Making of kachori with the name KUKU NAMKEEN in 1965 and the Brand was introduce by
                            this two brothers.
                            they invented the new taste type of kachori "Delux Kachori"/"Dryfruit Kachori".
                        </p>
                        <p>
                            Today Kuku Namkeen Complete 60 years and people know us as sign of premium taste of namkeen.
                        </p>
                    </div>

                    {/* 4th Generation */}
                    <div className="history-block">
                        <h3 className="heading-title mb-3">
                            The fourth generation proudly carries this legacy forward.
                        </h3>
                        <p>
                            The 4th Generation of the Family (new products introduced)<br />
                            Mr.Sandeep Kishorchandra Vasu &amp; Mr.Bharat Kishorchandra Vasu has decide to hand over the Business of
                            Kuku Namkeen to Young Generation who are take the brand name to new height of success.
                        </p>
                        <p>
                            in the year 2021 that time known as difficult for every busines because after the COVID-19 all new
                            startups are affected.
                            but here in this year the Brand Kuku Namkeen is hand over by this three from Young Generation of
                            Vasu Family.
                        </p>
                        <p>
                            <span className='text-black font-semibold'>1. Mr.Darshan Sandeepbhai Vasu</span><br />
                            <span className='text-black font-semibold'>2. Mr.Rushi Bharatbhai Vasu</span><br />
                            <span className='text-black font-semibold'>3. Mr.Vishvesh Sandeepbhai Vasu</span>
                        </p>
                        <p>
                            this three young brother decide to develope the brand to next level they take a first step to build
                            the Large workshop for mass production and not only for kachori they starts to making "sweets" too
                            (Gulabpaak, Kaju Katli) for winter season (Khajurpaak, Adadiya, Anjirpaak).
                            till now three type of kachori Kuku Namkeen is produce (Chapati kachori, Delux Kachori, Dryfruit
                            Kachori).
                        </p>
                        <p>
                            Yougster of the Family Decide to invent new taste of kachori and now after 3 years of experience they
                            introduced new Premium Royal Taste of Kachori and they called it as "Rajbhog Kachori" the royal
                            taste from Premium <br />
                            People of Jamnagar Likes the new taste of kachori and this young pioneers feel proud of it.
                        </p>
                        <p>at this time they on the way to promote it at Pan India across the all states and cities.</p>
                    </div>

                    {/* Unforgettable Taste */}
                    <div className="history-block">
                        <h3 className="heading-title mb-3">Unforgottable taste</h3>
                        <p>
                            the process of making of quality products is hygienic <span className='text-black font-semibold'>no palm oil, no preservatives</span> used in
                            any products of Kuku Namkeen
                            this is the reason behind authentic taste of our products.
                        </p>
                    </div>

                    {/* Stay Connected */}
                    <div className="history-block">
                        <h3 className="heading-title mb-3">Taste it like it</h3>
                        <p>
                            kuku namkeen is available in All across India at your doorstep <br />
                            More products to be added soon in this tasteful variety of Kuku Namkeen. <br />
                            the journey is continue Stay Connect with us.
                        </p>
                    </div>

                </div>
            </section>
        </>
    );
}

export default About;
